import { Link } from 'react-router-dom';
import { strengthsData } from '../../data/strengths';
import { useInView } from '../../hooks/useInView';
import styles from './Strengths.module.css';

const ROW_COLORS = ['#0c1a2e', '#132840', '#0c1a2e', '#132840', '#0c1a2e'];

export function Strengths() {
  const { ref, inView } = useInView();

  return (
    <section className={styles.section} id="strengths">
      <div
        ref={ref}
        className={`${styles.intro} ${inView ? styles.introVisible : ''}`}
        aria-hidden={false}
      >
        <span className={styles.watermark} aria-hidden="true">
          STRENGTHS
        </span>
        <div className="wrap">
          <div className={styles.eyebrow}>
            <span className={styles.eyebrowLine} />
            <span className={styles.eyebrowText}>WHY MEDI-LAWYER</span>
          </div>
          <h2 className={styles.heroTitle}>
            <span className={styles.heroWord}>메디로이어의</span>
            <span className={`${styles.heroWord} ${styles.heroAccent}`}>강점</span>
          </h2>
          <p className={styles.heroSub}>의료사건에서 결과를 바꾸는 다섯 가지 차이</p>
        </div>
      </div>

      <div className={styles.rows}>
        {strengthsData.map((s, i) => {
          const bg = ROW_COLORS[i];
          const nextBg = ROW_COLORS[i + 1] ?? null;
          return (
            <StrengthBanner
              key={s.slug}
              item={s}
              index={i}
              bg={bg}
              nextBg={nextBg}
              flip={i % 2 === 1}
            />
          );
        })}
      </div>
    </section>
  );
}

function StrengthBanner({ item, index, bg, nextBg, flip }) {
  const { ref, inView } = useInView();
  // polygon points: flip=false → \ direction, flip=true → / direction
  const points = flip ? '0,0 1440,48 0,48' : '0,48 1440,0 1440,48';

  return (
    <div className={styles.banner} style={{ background: bg }}>
      <div className="wrap">
        <article
          ref={ref}
          className={`${styles.row} reveal ${inView ? 'visible' : ''}`}
          style={{ transitionDelay: `${index * 70}ms` }}
        >
          <span className={styles.num}>0{index + 1}</span>
          <div className={styles.body}>
            <h3 className={styles.title}>{item.title}</h3>
            <p className={styles.desc}>{item.desc}</p>
          </div>
          <Link to={`/cases/${item.caseSlug}`} className={styles.caseLink}>
            <span>{item.caseLabel}</span>
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path
                d="M3 8h10M9 4l4 4-4 4"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        </article>
      </div>

      {nextBg && (
        <div className={styles.divider} style={{ background: bg }}>
          <svg viewBox="0 0 1440 48" preserveAspectRatio="none" aria-hidden="true">
            <polygon points={points} fill={nextBg} />
          </svg>
        </div>
      )}
    </div>
  );
}
